import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import { LocalCacheService } from "./local-cache-service";
import * as moment from "moment";

export class PartyGroupService extends RLBaseService {

    static $inject = ["$resource", "$q", "localCacheService"];

    private fiveMins = moment.duration(5, "minutes");

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService, private localCacheService: LocalCacheService) {
        super($resource);
    }

    createPartyGroup(partyGroup: Models.IPartyGroup) {
        var promise = this.toRLService<number>("/api/partygroup/createpartygroup").post(partyGroup).$promise;
        promise.then(() => this.localCacheService.clearAll());
        return promise;
    }

    deletePartyGroup(partyGroupID: number) {
        var data = { partyGroupID: partyGroupID };
        var promise = this.toRLService<boolean>("/api/partygroup/deletepartygroup").delete(data).$promise;
        promise.then(() => this.localCacheService.clearAll());
        return promise;
    }

    updatePartyGroup(partyGroup: Models.IPartyGroup) {
        var promise = this.toRLService<boolean>("/api/partygroup/updatepartygroup").post(partyGroup).$promise;
        promise.then(() => this.localCacheService.clearAll());
        return promise;
    }

    getPartyGroupList() {
        return this.toRLService<Models.IPartyGroup>("/api/partygroup/getpartygrouplist").query().$promise;
    }

    updatePartyGroupSequenceNumber(partyGroupID: number, moveUp: boolean) {
        var data = { partyGroupID: partyGroupID, moveUp: moveUp };
        var promise = this.toRLService<boolean>("/api/partygroup/updatepartygroupsequencenumber").post(data).$promise;
        promise.then(() => this.localCacheService.clearAll());
        return promise;
    }

    getPartyGroupDataCount(partyGroupID: number) {
        var data = { partyGroupID: partyGroupID };
        var key = `getPartyGroupDataCount_${partyGroupID}`;
        return this.localCacheService.getCachedOrDoCachePromise(key, () => this.toRLService<any>("/api/partygroup/getpartygroupdatacount").get(data).$promise, this.fiveMins);
    }

    getPartyGroupDataCountPerCharAndTemplate(partyGroupID: number, charTypeID: number, charTemplateTypeID: number) {
        var data = { partyGroupID: partyGroupID, charTypeID: charTypeID, charTemplateTypeID: charTemplateTypeID };
        return this.toRLService<any>("/api/partygroup/getpartygroupdatacount").get(data).$promise;
    }
}